exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1geZK{-webkit-box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.05);box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.05);padding-top:30px}._2l05G{width:1200px;margin:0 auto}._39Hac{width:1180px;margin:0 auto}._1WjVc,._11Z1B{color:#36404a;font-size:26px}._1WjVc{margin-top:30px;margin-left:10px;margin-bottom:10px}._11Z1B{margin-top:30px;margin-bottom:18px}._2hEvT{background:red}._1QTHW{margin-top:18px}._1445A{margin-top:10px}.WapT-{margin-top:20px}.THTpo{margin:42px auto -10px 10px}", ""]);

// exports
exports.locals = {
	"wrapper": "_1geZK",
	"content": "_2l05G",
	"smallArea": "_39Hac",
	"title": "_1WjVc",
	"allTitle": "_11Z1B",
	"courseCard": "_2hEvT",
	"slideContainer": "_1QTHW",
	"gap": "_1445A",
	"gap2": "WapT-",
	"serial": "THTpo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/routes/tag/Tag.css
// module id = 1256
// module chunks = 2